import React, { Component } from "react";
import { Spin } from "antd";
import { parse } from "qs";
import { connect } from "dva";
import Evaluation from "../../components/EvaluationStatistic";
import TreeList from "../../components/TreeList";
import Norm from "../../components/NormComponent";
import Self from "../../components/SelfComponent";
import styles from "./tree.less";

@connect(({ evaluationStatistic }) => ({
  spinProps: evaluationStatistic.spinProps,
  index: evaluationStatistic.index,
  self: evaluationStatistic.self,
  targetList: evaluationStatistic.targetList,
  templateType: evaluationStatistic.templateType
}))
class EvaluationTree extends Component {
  constructor(props) {
    super(props);

    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId, currentOrgId } = query;

    this.state = {
      currentProjectId,
      currentOrgId,
      showTree: false,
      indexId: "", // 指标详情Id
      selectEvaluateType: 0 // 指标类型 1-分组 2-详情
    };
  }

  componentDidMount() {
    this.getTreeList();
    this.getItemInfo();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "tree/reset"
    });
    dispatch({
      type: "evaluationStatistic/reset"
    });
  }

  getTreeList = id => {
    const { currentProjectId, currentOrgId } = this.state;
    const { dispatch, org } = this.props;
    dispatch({
      type: "tree/fetchEvaluationAllTree",
      payload: {
        projectId: id || currentProjectId,
        targetOrgId: currentOrgId,
        org: org || false
      },
      callback: () => {
        this.setState({
          showTree: true
        });
      }
    });
  };

  handleChangeSelect = ({ type, code }) => {
    this.setState(
      {
        selectEvaluateType: type,
        indexId: code
      },
      () => {
        if (type === 2) {
          this.getItemInfo();
        }
      }
    );
  };

  getItemInfo = () => {
    const { currentOrgId, currentProjectId, indexId } = this.state;
    const { dispatch, org } = this.props;
    if (indexId) {
      dispatch({
        type: "evaluationStatistic/fetchItemInfo",
        payload: {
          indexId,
          targetOrgId: currentOrgId,
          projectId: currentProjectId,
          org: org || false
        }
      });
    }
  };

  renderRightSide = () => {
    const { selectEvaluateType } = this.state;
    const { index, targetList, self, templateType } = this.props;

    if (selectEvaluateType === 1 || selectEvaluateType === 0) {
      return null;
    }
    if (window.document.getElementById("right-side-evaluation-tree")) {
      window.document.getElementById(
        "right-side-evaluation-tree"
      ).scrollTop = 0;
    }

    return (
      <div className="right-side" id="right-side-evaluation-tree">
        <div className="rightSideContainer">
          <Norm
            formType="detail"
            templateType={templateType}
            from="evaluate"
            {...index}
          />
          <Self
            formType="detail"
            templateType={templateType}
            from="evaluate"
            {...self}
          />
          {targetList?.length ? (
            targetList.map((item, itemIndex) => {
              return (
                <Evaluation
                  templateType={templateType}
                  {...item}
                  nowIndex={itemIndex}
                />
              );
            })
          ) : (
            <Evaluation templateType={templateType} nowIndex={0} />
          )}
        </div>
      </div>
    );
  };

  render() {
    const { spinProps } = this.props;
    const { showTree } = this.state;

    return (
      <div className={styles.tree}>
        <Spin {...spinProps} wrapperClassName="evaluationNormTreeSpin">
          <div className="container">
            <div className="norm-wrap">
              <div className="left-side">
                <div className="leftSideContainer">
                  {showTree && (
                    <TreeList
                      needRememberNowNode={0}
                      onSelect={this.handleChangeSelect}
                      expandAllTree
                    />
                  )}
                </div>
              </div>
              {this.renderRightSide()}
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}

export default EvaluationTree;
